import { Linkedin } from 'lucide-react';

import { PortalEmptyState } from '@/modules/hiring-manager/components/portalEmptyState/PortalEmptyState';

interface ConnectLinkedInPromptProps {
  integrationsHref?: string;
}

/**
 * Shown instead of the log when the user has no LinkedIn account at all.
 * Setup goes through the selected tenant's authorized Integrations flow.
 */
export function ConnectLinkedInPrompt({
  integrationsHref,
}: ConnectLinkedInPromptProps) {
  return (
    <PortalEmptyState
      {...(integrationsHref
        ? { action: { label: 'Connect LinkedIn', to: integrationsHref } }
        : {})}
      description={
        integrationsHref
          ? 'Finlay sends connection requests and messages from your LinkedIn account.'
          : 'This workspace cannot connect your LinkedIn account. Switch workspaces or ask your recruiter for help.'
      }
      icon={Linkedin}
      title="Connect your LinkedIn account"
    />
  );
}
